import Button from 'components/button/Button';
import { Row } from '@tanstack/react-table';
import {
  IntegrationCategory,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import { useTranslation } from 'react-i18next';
import useChannelDescriptionModal from 'pages/channels/components/modals/channelDescription/useChannelDescriptionModal';
import { ChannelCellWrapper } from './ChannelCell.styles';

const ChannelCell = ({ row }: { row: Row<InternalIntegrationSetting> }) => {
  const { t } = useTranslation();
  const { name, logo, displayName } = row.original.integration;
  const { openChannelDescriptionModal } = useChannelDescriptionModal();

  const channelName = displayName ?? name;
  const isChannelManager =
    row.original.integration.category === IntegrationCategory.CHANNEL_MANAGER;

  return (
    <ChannelCellWrapper>
      <img
        src={logo}
        alt={`${channelName} logo`}
        width={48}
        height={48}
        loading="lazy"
      />

      <p>{channelName}</p>

      <Button
        bsStyle="link"
        onClick={(e) => {
          e.stopPropagation();
          openChannelDescriptionModal(row.original);
        }}
        data-testid="channel-description-button"
      >
        {isChannelManager
          ? t('pageChannels.table.viewChannelManagerDescription')
          : t('pageChannels.table.viewChannelDescription')}
      </Button>
    </ChannelCellWrapper>
  );
};

export default ChannelCell;
